<template>
  <div class="text-left">
    <Upload ref="upload"  :action="upLoadURL" :headers="headers" :data="{
      'src_id': attForm.src_id,
      'src_name': attForm.src_name,
      'att_category': attForm.att_category.value}" :show-upload-list="showuploadlist" accept="accept" :multiple="multiple" :on-success="uploaded" :format="format" :max-size="51200" :on-error="doFailed"
      :on-format-error="handleFormatError" :on-exceeded-size="hanhdleMaxSize" :on-remove="remove">
        <Button icon="ios-cloud-upload-outline">{{title}}</Button>
    </Upload>
    </div>
  </div>
  </div>
</template>

<script type="text/ecmascript-6">
const COMP_NAME = 'DsUpload'
export default {
  name: COMP_NAME,
  props: {
    attForm: {
      type: Object,
      required: true
    },
    format: {
      type: Array,
      default: () => {
        return ['gif', 'jpg', 'jpeg', 'png', 'pdf', 'mp3', 'aac', 'wav', 'wma', 'cda', 'flac', 'm4a', 'mid', 'mka', 'mp2', 'mpa', 'mpc', 'ape', 'ofr', 'ogg', 'ra', 'wv', 'tta', 'ac3', 'dts', 'avi', 'asf', 'wmv', 'avs', 'flv', 'mkv', 'mov', '3gp', 'mp4', 'mpg', 'mpeg', 'dat', 'ogm', 'vob', 'rm', 'rmvb', 'ts', 'tp', 'ifo', 'nsv']
      }
    },
    accept: {
      type: String,
      default: '*'
    },
    title: {
      type: String,
      default: '点击上传'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    showuploadlist: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    attForm (n) {
      console.log(n, 'dsfd')
    }
  },
  data () {
    return {
      img: '',
      upLoadURL: this.$store.state.common.baseURL + this.$URLS.attUpload,
      headers: {
        'Authorization': this.$store.state.common.tokenPre + localStorage.getItem(this.$store.state.common.keyToken),
        'AppCode': window.sessionStorage.getItem(this.$store.state.common.AppCode),
        'MenuCode': this.attForm.menu_code
      },
      token: localStorage.getItem(this.$store.state.common.keyToken),
      visible: false,
      uploadList: []
    }
  },
  methods: {
    handleFormatError (file) {
      this.$Notice.warning({
        title: file.name + '文件格式错误',
        desc: '当前仅支持pdf、音频文件、图片'
      })
    },
    // 音频文件上传过大
    hanhdleMaxSize (file) {
      this.$Notice.warning({
        title: file.name + '太大啦,不能超过50M'
      })
    },
    handleView (item) {
      if (item.type !== 'img') {
        this.showAtt(item.response.StaticURL)
        return
      }
      this.visible = true
      this.img = this.$store.state.common.baseURL + item.response.StaticURL + '?Authorization=' + this.token
    },
    uploaded (res, file, fileList) {
      let obj = res.obj
      let name = obj.att_name
      let type = this.$checkFilesType(name)
      obj.type = type
      if (this.multiple) {
        this.uploadList.push(obj)
      } else {
        this.uploadList = [obj]
      }
      console.log(this.uploadList)
      this.$emit('getupload', this.uploadList)
    },
    doFailed (res, info) {
      this.$Message.error(info.message)
    },
    remove (file, fileList) {
      this.$emit('remove', file.response.ID)
    },
    initUploadList () {
      this.$refs.upload.fileList = []
    }
  },
  mounted () {
  }
}
</script>

<style type="text/stylus" lang="stylus" rel="stylesheet/stylus">
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.demo-upload-list .myView {
  width: 100%;
  height: 100%;
}

.demo-upload-list span.myView {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  font-size: 12px;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  margin: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/dsupload/DsUpload.vue